import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BigFiveState, bigFiveFeatureKey } from '@stores/big-five/big-five.reducer';

const selectBigFive = createFeatureSelector<BigFiveState>(bigFiveFeatureKey);

export const selectBigFiveResults = createSelector(selectBigFive, (state) => state.results);
export const hasBigFiveResults = createSelector(selectBigFiveResults, (results) => !!results);
